<template>
    <el-dialog title="请选择城市" :visible.sync="dialogTableVisible" :lock-scroll="false" :before-close="close">
        <div class="city column">
            <div class="city_top row">
                <div v-for="(item, index) in FristPin" :key="index"
                    :class="index == FristPinVal ? 'city_top_m2' : 'city_top_m'" @click="clickpinyin(item, index)">{{
                        item
                    }}</div>
            </div>
            <div class="city_hot_m" v-if="FristPinVal == 0">
                <div class="city_hot_mm row">
                    <div class="city_hot_m_m" v-for="(item, index) in clickCityArr " :key="index"
                        @click="clickchengshi(item)">
                        {{ item.name }}
                    </div>
                </div>
            </div>
            <div class="city_m column" v-else>
                <div class="city_mm row" v-for="(item, index) in clickCityArr " :key="index">
                    <div class="city_m_l">{{ item.title }}</div>
                    <div class="city_m_r row">
                        <div class="city_m_r_m" v-for="(ite, inde) in item.data" :key="inde" @click="clickchengshi(ite)">{{
                            ite.name }}</div>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import pinyin from 'js-pinyin'
import { CityList, CityHotList } from "@/api/data/city.js";

export default {
    components: {

    },
    data() {
        return {
            dialogTableVisible: true,
            city: {},
            FristPinVal: 0,
            FristPin: ["热门城市", "ABCDE", "FGHJ", "KLMN", "PQRST", "WXYZ"],
            cityjson: {},
            cityArr: [],
            clickCityArr: [],
        }
    },
    mounted() {
        this.clickCityArr = CityHotList;
        //先拿到全部城市的名字
        this.cityArr = [];
        for (let i = 0; i < CityList.length; i++) {
            //遍历数组,拿到城市名称
            let cityName = CityList[i].name;
            //取全部城市的首字母
            let fristName = pinyin.getCamelChars(cityName).substring(0, 1);    //这里截取首字母的第一位
            //给原json添加首字母键值对
            CityList[i].first = fristName;
            //放入新数组
            this.cityArr.push(CityList[i]);
        }
    },
    activated() {
    },
    methods: {
        clickpinyin(val, index) {
            this.FristPinVal = index;
            this.clickCityArr = [];
            if (index == 0) {
                this.clickCityArr = CityHotList;
            } else {
                for (let i = 0; i < val.length; i++) {
                    console.log(val[i]);
                    let dataObj = {
                        title: val[i],
                        data: []
                    }
                    for (let j = 0; j < this.cityArr.length; j++) {
                        if (this.cityArr[j].first == val[i]) {
                            dataObj.data.push(this.cityArr[j])
                        }
                    }
                    this.clickCityArr.push(dataObj)
                }
            }

        },
        clickchengshi(item) {
            this.city = item;
            this.close();
        },
        close() {
            this.$emit('clickCity', { state: false, city: this.city });
        },
    }

}
</script>

<style scoped>
.city {
    width: 100%;
}

.city_top {
    background: #f9fafb;
    overflow: hidden;
    width: 100%;
    height: 39px;
    justify-content: space-around;
}

.city_top_m {
    line-height: 39px;
    font-size: 14px;
    color: #424a5e;
    cursor: pointer;
}

.city_top_m:hover {
    color: #00b277;
}

.city_top_m2 {
    color: #00b277;
    line-height: 39px;
    font-size: 14px;
    cursor: pointer;
    border-bottom: 2px solid #00b277;
}

.city_m {
    padding: 20px 0;
    height: 378px;
    overflow: overlay;
}

.city_m::-webkit-scrollbar {
    width: 5px;
}

.city_m::-webkit-scrollbar-track {
    background: #fff;
}

.city_m::-webkit-scrollbar-thumb {
    background: #9993;
    border-radius: 5px;
}

.city_m::-webkit-scrollbar-thumb:hover {
    background: #fff;
}

.city_mm {
    align-items: baseline;
}

.city_m_l {
    width: 11.2%;
    text-align: center;
    color: #00b277;
    float: left;
}

.city_m_r {
    float: left;
    width: 88.8%;
    flex-wrap: wrap;
}

.city_m_r_m {
    width: 20%;
    text-align: left;
    margin-bottom: 8px;
    float: left;
    line-height: 40px;
    cursor: pointer;
    padding-right: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.city_m_r_m:hover {
    color: #00b277;
}

.city_hot_m {
    padding: 20px 0;
    height: 378px;
}

.city_hot_mm {
    width: 100%;
    height: 160px;
    flex-wrap: wrap;
}

.city_hot_m_m {
    line-height: 40px;
    width: 20%;
    height: 40px;
    cursor: pointer;
    text-align: center;
    margin-bottom: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: color .2s linear;
}

.city_hot_m_m:hover {
    color: #00b277;
}
</style>
